import { gql } from '@apollo/client';

export const UPDATE_MONITORINGFORM_CONFIGURE = gql`
  mutation UpdateMonitoringFormConfigure($input: UpdateMonitoringFormConfigureInput!) {
    monitoringForm: updateMonitoringFormConfigure(input: $input) {
      id
      users {
        id
        user {
          id
        }
      }
      dueDates {
        id
        periodNumber
      }
    }
  }
`;
